import React from 'react'
import _ from 'lodash'
import moment from 'moment'

import {HeaderBlock} from '../widgets/layout/headerblock.component'
import {TravelItem} from './travelitem.component'
import {ListItemBlock} from '../widgets/layout/listitemblock.component'

export class TravelList extends React.Component {
    constructor(props) {
        super(props)  

        this.state = {
            showSearchItem: false,
            selectedSearchItem: null,
            fullSearchItem: null
        }

        _.bindAll(this,
  	  'updateTravelStatuses',
            'getListHeader',
            'getSubSections',
            'getBlocks',
            'formatDuration',
            'activateSearchItem',
            'deActivateSearchItem',
            'onRemoveActiveTransportation'
        )
    }

    //  shouldComponentUpdate(nextProps, nextState){
	  //   // if(this.props.transportation !== nextProps.transportation){
	  //   //   return true
	  //   // }else{
	  //   //   return false
	  //   // }
	  // }


    formatDuration(duration) {
  	if (duration > 0) {
	    // TODO: I think duration is in minutes. need to confirm
	    let d = duration * 60000 // convert to milliseconds
	    let t = moment.duration(d)
	    return <span>{t.hours()}h {t.minutes()}m</span>
        } else {
            return null
        }
    }

    updateTravelStatuses(subSection, subDetail) {
  	this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, subSection, subDetail)
    }

    activateSearchItem(item) {
  	let tItem = item.get('transportation')
        this.setState({showSearchItem: true, selectedSearchItem: tItem, fullSearchItem: item})
    }

    deActivateSearchItem() {
        this.setState({showSearchItem: false, selectedSearchItem: null})
    }

    onRemoveActiveTransportation(item) {
  	this.props.onRemoveTransportation(this.state.fullSearchItem)
  	this.setState({showSearchItem: false, selectedSearchItem: null})
    }

    getListHeader() {
	    if (this.props.detailSection !== this.props.availableDetailSections.OVERVIEW) {
	      return (
    <HeaderBlock header="Let’s get started with your travel" body="Start exploring one of the categories below or let Luna take care of the details."/>
	      )
	    } else {
	      return (
	      	null
	      )
	    }
    }

    getBlocks(subSection) {
  	// defaults
  	let travelItems = null
  	let iconClass = 'icon-plane_right'
  	let hasItems = false
  	let sectionLabel = ''

        switch (subSection) {
            case this.props.availableDetailSubDetails.ARRIVAL:
                sectionLabel = 'Getting There'
                travelItems =	this.props.transportation.filter((item) => {
		  		// if arriving here but not also leaving from here (which would be local travel)
		  		if (item.getIn(['legArr']) === this.props.leg.getIn(['id']) && item.getIn(['legArr']) !== item.getIn(['legDep'])) {
		  			return true
		  		} else {
		  			return false
		  		}
		  	})
                break
            case this.props.availableDetailSubDetails.LOCAL:
                sectionLabel = 'Getting Around'
                iconClass = 'icon-car'
                travelItems = this.props.transportation.filter((item) => {
		  		// if arriving = departing = this leg
		  		if (item.getIn(['legArr']) === this.props.leg.getIn(['id']) && item.getIn(['legDep']) === this.props.leg.getIn(['id'])) {
		  			return true
		  		} else {
		  			return false
		  		}
		  	})
                break
            case this.props.availableDetailSubDetails.DEPARTURE:
                sectionLabel = 'Leaving'
                iconClass = 'icon-plane_left h-flip'
                travelItems = this.props.transportation.filter((item) => {
		  		// if arriving here but not also leaving from here (which would be local travel)
		  		if (item.getIn(['legDep']) === this.props.leg.getIn(['id']) && item.getIn(['legArr']) !== this.props.leg.getIn(['id'])) {
		  			return true
		  		} else {
		  			return false
		  		}
		  	})
                break
            default:
                console.log('There was an error formatting the travel items in travellist.Component')
                return ''
                break
        }

        // lets print some stuff
        if (travelItems.count() > 0) {
	  	let items = ''
	  	if (travelItems.count() > 0) {
	  		items = travelItems.map((item, index) => {
	  			// get the modes of transportation
			    let vehicles = item.getIn(['transportation', 'segments']).map((segment, index) => {
			      let icon = 'icon-bike'
			      if (segment.getIn(['vehicle']) && segment.getIn(['vehicle', 'kind'])) {
			        switch (segment.getIn(['vehicle', 'kind'])) {
			          case 'plane':
			            icon = 'icon-plane'
			          break
			          break
			          case 'taxi':
			            icon = 'icon-car'
			          break
			        }
			        return <i key={index} className={icon}/>
			      }
			    })

			    let itemDuration = this.formatDuration(item.getIn(['transportation', 'totalDuration']))

	  			return (
    <ListItemBlock {...this.props} subSection={subSection} key={index} item={item} vehicles={vehicles} itemDuration={itemDuration} showDetails={this.activateSearchItem} onRemoveTransportation={this.props.onRemoveTransportation} type="transportation"/>
	  			)
	  		})	
	  	}

            return (
                <div>
                    <div className="itinerary-item-group group-label">
                        <div className="itin-item-group-icon">
                            <i className={iconClass}/>
                        </div>
                        <div className="itin-item-group-blocks">
                            <div className="itin-item-group-block itin-item-group-block-start nopad">
                                <div>
                                    <h1>{sectionLabel}</h1>
                                </div>
                                <div>
                                    <a className="btn btn-flex" onClick={() => this.updateTravelStatuses(this.props.availableDetailSubSections.SEARCH, subSection) }>Search</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {items}
                </div>
            )
        } else {
            return (
                <div className="itinerary-item-group group-label">
                    <div className="itin-item-group-icon">
                        <i className={iconClass}/>
                    </div>
                    <div className="itin-item-group-blocks">
                        <div className="itin-item-group-block itin-item-group-block-start nopad">
                            <div>
                                <h1>{sectionLabel}</h1>
                            </div>
                            <div>
                                <a onClick={() => this.updateTravelStatuses(this.props.availableDetailSubSections.SEARCH, subSection)} className="btn btn-flex">Search</a>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    getSubSections() {
  	if (this.props.detailSection !== this.props.availableDetailSections.OVERVIEW || this.props.transportation.count() > 0) {
  		let blockClass = this.props.transportation.count() > 0 ? 'travelList hasBlocks' : 'travelList'
  		return (
      <div className={blockClass}>
          { this.getBlocks(this.props.availableDetailSubDetails.ARRIVAL) }
          { this.getBlocks(this.props.availableDetailSubDetails.LOCAL) }
          { this.getBlocks(this.props.availableDetailSubDetails.DEPARTURE) }
      </div>
  		)
  	}
    }


  	render() { 
  	 if (this.state.showSearchItem) {
		    return <TravelItem {...this.props} inItin={true} getDuration={this.formatDuration} goBack={ this.deActivateSearchItem } item={ this.state.fullSearchItem }  addTransportation={this.props.addTransportation} onRemoveTransportation = {this.onRemoveActiveTransportation}/>
		  } else { 		
		    return (
    <div className="view-area">
        <div className="view-left-col"/>
        <div className="view-center">
            {this.getListHeader()}
            {this.getSubSections()}
        </div>
        <div className="view-right-col"/>
    </div>
            )
		  }
	  }
}

	  				// TODO: Update ListItemBlock for travel item and replace this
	  				// <div className="list-item-block" key={index}>
			    //     <div className="list-item-body">
			    //       <a onClick={() => this.activateSearchItem(item)}><h1>{item.getIn(['transportation','name'])}</h1></a>
			    //       <div className="travel-icons-small">
		  			// 			{vehicles}
		  			// 			{itemDuration}
		  			// 		</div>			          
			    //     </div>
			    //     <div className="list-item-details">
			  		// 			<div className="list-item-addedby">Added by {item.getIn(['added_by'])}</div>
			    //     </div>
			    //     <div className="list-item-actions">
			    //       <div className="list-item-tools">
			    //         <i className="icon-close" onClick={() => {if(confirm('Are you sure you want to delete this option?')){this.props.onRemoveTransportation(item)}}}></i>
			    //       </div>
			    //     </div>
			    //   </div>